import { useTagStore } from '~/stores/tag'

export default defineNuxtRouteMiddleware(async () => {
  const { $pinia } = useNuxtApp()

  const { FETCH: FETCH_TAGS } = useTagStore($pinia)
  await callOnce('FETCH_TAGS', FETCH_TAGS)
})
